import { CheckCircle2, Circle, Star } from "lucide-react";

export const Challenges = ({ list }) => !list?.length ? null : (
  <div data-testid="bp-challenges" className="mt-4">
    <div className="rg-label mb-1">Today's challenges</div>
    <ul className="space-y-1">{list.map((c) => (
      <li key={c.key} data-testid={`bp-challenge-${c.key}`} className="flex items-center gap-2 text-xs">
        {c.done ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> : <Circle className="h-3.5 w-3.5 text-slate-600" />}
        <span className={c.done ? "text-slate-500 line-through" : "text-slate-300"}>{c.label}</span>
        <span className="ml-auto font-mono text-slate-500">{c.progress}/{c.target} · +{c.xp} XP</span>
      </li>))}</ul>
  </div>
);

export const PremiumStatus = ({ p }) => p.premium
  ? <p data-testid="bp-premium-active" className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-amber-300"><Star className="h-4 w-4 fill-amber-300" />Premium unlocked for season {p.season}</p>
  : <p data-testid="bp-premium-info" className="mt-3 text-xs text-slate-500">Premium track rewards are granted by server staff.</p>;
